module.exports = __webpack_public_path__ + "assets/fs-daishouhuo.b792c0f6.svg";